import { styled } from '@fluentui/react';
import { FormTitleBase } from './FormTitle.base';
import { getStyles } from './FormTitle.styles';
import { IFormTitleProps, IFormTitleStyleProps, IFormTitleStyles } from './FormTitle.types';

export const FormTitle = styled<IFormTitleProps, IFormTitleStyleProps, IFormTitleStyles>(FormTitleBase, getStyles, undefined, {
  scope: 'FormTitle',
});
